import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { AnalyticsEventName, ToolNames } from '@/shared/config';

import { ToolbarReportType } from './types';

const DEFAULT_2D_TOOLBAR_CONTROLS: ToolNames[] = [
  'expand',
  'brightness',
  'sharpness',
  'reset',
  'download',
  'editNumbers',
  'editMask',
];

const FILTERED_2D_TOOLBAR_CONTROLS: ToolNames[] =
  DEFAULT_2D_TOOLBAR_CONTROLS.filter((tool) => tool !== 'download');

export const REPORT_TOOLBAR_CONTROLS: Record<ToolbarReportType, ToolNames[]> = {
  [ReportType.ReportType_CBCT_GP]: [
    'expand',
    'split',
    'brightness',
    'sharpness',
    'invert',
    'reset',
    'download',
    'editNumbers',
    'editMask',
  ],
  [ReportType.ReportType_Pano_GP]: DEFAULT_2D_TOOLBAR_CONTROLS,
  [ReportType.ReportType_IOXRay_GP]: [...FILTERED_2D_TOOLBAR_CONTROLS, 'turn'],
  [ReportType.ReportType_Pano_Bitewings]: [
    ...FILTERED_2D_TOOLBAR_CONTROLS,
    'turn',
  ],
};

export const DEFAULT_SLICE_CONTROLS: ToolNames[] = [
  'ruler',
  'arrow',
  'eraser',
  'brightness',
  'sharpness',
  'angle',
  'reset',
  'download',
];

export const MOBILE_EXCLUDED_TOOLS: ToolNames[] = [
  'expand',
  'brightness',
  'sharpness',
  'editNumbers',
  'editMask',
  'reset',
];

export { TOOL_NAME_TO_ICON_MAPPING } from '@/shared/config';

export const TOOLBAR_EVENT_MAPPING: Partial<
  Record<ToolNames, AnalyticsEventName>
> = {
  expand: 'ReportPagePanoramaExpandButtonClicked',
  split: 'ReportPagePanoramaSplitButtonClicked',
  brightness: 'ReportPagePanoramaBrightnessContrastButtonClicked',
  sharpness: 'ReportPagePanoramaSharpnessButtonClicked',
  invert: 'ReportPagePanoramaInvertButtonClicked',
  reset: 'ReportPagePanoramaResetButtonClicked',
  download: 'ReportPagePanoramaDownloadButtonClicked',
};
